import { useI18n } from "@/i18n/I18nProvider";

function HeroCtas({ t }) {
    return (
        <div
            className="itly-anim delay-3"
            style={{
                marginTop: 36,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 12,
                flexWrap: "wrap",
            }}
        >
            <a
                href="#candidati"
                data-testid="hero-cta-primary"
                className="itly-btn-primary"
            >
                {t("partner.hero.cta")}
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                </svg>
            </a>
            <a
                href="#perche"
                data-testid="hero-cta-secondary"
                className="itly-btn-secondary"
            >
                {t("partner.hero.cta2")}
            </a>
        </div>
    );
}

function HeroProof({ t }) {
    return (
        <div
            className="itly-anim delay-5 itly-hero-proof"
            data-testid="hero-proof"
            style={{
                marginTop: 28,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 20,
                flexWrap: "wrap",
                color: "var(--itly-muted)",
                fontFamily: "Inter, sans-serif",
                fontSize: 13.5,
            }}
        >
            <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                <span className="itly-proof-dot" aria-hidden="true" />
                <span>{t("partner.proof.free")}</span>
            </span>
            <span className="itly-proof-sep" aria-hidden="true" />
            <span>{t("partner.proof.noFee")}</span>
            <span className="itly-proof-sep" aria-hidden="true" />
            <span>{t("partner.proof.autoVerify")}</span>
            <span className="itly-proof-sep" aria-hidden="true" />
            <span>{t("partner.proof.qr")}</span>
        </div>
    );
}

export default function Hero() {
    const { t } = useI18n();
    return (
        <section
            id="visione"
            data-testid="hero-section"
            style={{
                position: "relative",
                overflow: "hidden",
                background: "var(--itly-page)",
            }}
        >

            <div
                style={{
                    position: "relative",
                    zIndex: 1,
                    maxWidth: 1040,
                    margin: "0 auto",
                    padding: "80px 32px 80px",
                    textAlign: "center",
                }}
            >
                <div
                    className="itly-badge itly-anim"
                    data-testid="hero-badge"
                    style={{ margin: "0 auto" }}
                >
                    <span className="spark" aria-hidden="true">✦</span>
                    <span>{t("partner.hero.badge")}</span>
                </div>

                <h1
                    className="itly-serif itly-anim delay-1 itly-hero-h1"
                    data-testid="hero-h1"
                    style={{
                        marginTop: 28,
                        marginBottom: 0,
                        fontSize: "clamp(46px, 5.4vw, 76px)",
                        lineHeight: 1.02,
                        color: "var(--itly-fg-strong)",
                        letterSpacing: "-0.022em",
                    }}
                >
                    {t("partner.hero.h1_a")}
                    <br />
                    <em
                        style={{
                            fontStyle: "italic",
                            color: "var(--itly-orange-500)",
                            fontWeight: 500,
                        }}
                    >
                        {t("partner.hero.h1_b")}
                    </em>
                </h1>

                <p
                    className="itly-anim delay-2"
                    data-testid="hero-sub"
                    style={{
                        marginTop: 26,
                        marginBottom: 0,
                        marginLeft: "auto",
                        marginRight: "auto",
                        fontFamily: "Inter, sans-serif",
                        fontSize: 19,
                        lineHeight: 1.55,
                        color: "var(--itly-muted)",
                        maxWidth: 780,
                    }}
                >
                    {t("partner.hero.sub")}
                </p>

                <HeroCtas t={t} />

                {/* Founder counter — indicative */}
                <FounderCounter />

                <HeroProof t={t} />
            </div>
        </section>
    );
}

function FounderCounter() {
    const { t } = useI18n();
    return (
        <div
            className="itly-anim delay-4 itly-founder-pill"
            data-testid="hero-founder-pill"
            style={{
                marginTop: 40,
                display: "inline-flex",
                alignItems: "center",
                gap: 14,
                padding: "10px 20px 10px 12px",
                background: "var(--itly-surface)",
                border: "1px solid var(--itly-border)",
                borderRadius: 999,
                boxShadow: "var(--itly-card-shadow)",
                fontFamily: "Inter, sans-serif",
                fontSize: 13.5,
                flexWrap: "wrap",
                justifyContent: "center",
            }}
        >
            <span
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                    color: "var(--itly-orange-700)",
                    fontWeight: 700,
                    padding: "4px 10px",
                    background: "var(--itly-peach-050)",
                    borderRadius: 999,
                    letterSpacing: "0.04em",
                    textTransform: "uppercase",
                    fontSize: 11.5,
                }}
            >
                {t("partner.founder.badge")}
            </span>
            <span style={{ color: "var(--itly-fg-strong)", fontWeight: 600 }} data-testid="founder-open-label">
                {t("partner.founder.open")}
            </span>
        </div>
    );
}

// Proof separator styles moved to CSS class `.itly-proof-sep` (see index.css)
// so mobile can hide/collapse them via media queries.
